import React, { useState }from 'react';
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux"; 
import { resetPagination } from 'reducers/paginationSentInicidentsSlice';
import { setFilters, resetFilters } from 'reducers/filtersSentInicidentsSlice'; 
import DashboardIcon from '@mui/icons-material/Dashboard';
import FeedIcon from '@mui/icons-material/Feed';
import SettingsIcon from '@mui/icons-material/Settings';
import LogoutIcon from '@mui/icons-material/Logout';
import { useTranslation } from "react-i18next"
import { Link } from 'react-router-dom';
import { Navigate } from 'react-router-dom'; 
import { ToastContainer } from 'react-toastify'; 
import { TodayIs} from 'components/utils/TodayIs';
import ImportScript from 'components/utils/ImportScript';
import Footer from "pages/main/Footer";
import Alerts from 'pages/alerts/Alerts';
import Person from 'pages/main/Person';
import Messages from 'pages/messages/Messages';
import IncidentList from 'pages/sentincidents/IncidentsList';
 
const HomeSentIncident = () => {
    const {t,i18n} = useTranslation(['listDataGeneralSettings']); 
    const dispatch = useDispatch();
    const filtersSentIncidentsDetails = useSelector((state) => state.filtersSentIncidents); // Obtener filtros desde Redux
    const state = useSelector((state) => state);
    const enabled = state.loginUser.enabled;
    const roles = state.loginUser.roles;
    const defaultStore = state.loginUser.defaultStore;
    const [showModalSentInicidents, setShowModalSentInicidents] = useState(true); 

    const scriptUrl = '/js/sb-admin-2.min.js'; 

    const changeSelectedLanguage = () => {
        if (i18n.language === "es") {
            i18n.changeLanguage("en");
            dispatch(setFilters({ slatypeFromES: "", slatypeToES: "",incidenttypeFromES: "", incidenttypeToES: "",resolutiontypeFromES: "", resolutiontypeToES: "" }));
        } else {
            i18n.changeLanguage("es");
            dispatch(setFilters({ slatypeFromEN: "", slatypeToEN: "",incidenttypeFromEN: "", incidenttypeToEN: "",resolutiontypeFromEN: "", resolutiontypeToEN: ""  }));
        }
    };

    const closeModalSentInicidents = () => {    
        dispatch(resetPagination());
        dispatch(resetFilters());
        setShowModalSentInicidents(false);
        return () => {};
    }; 

    return (
    <>
        <ImportScript resourceUrl={scriptUrl} />
        <ToastContainer/>
        {enabled===false ? <Navigate to="/"></Navigate>:
        <div id="page-top">
           
            {/* Page Wrapper */}
            <div id="wrapper">

                {/* Sidebar */}
                <ul className="navbar-nav bg-gradient-primary toggled sidebar sidebar-dark accordion" id="accordionSidebar">

                    {/* Sidebar - Brand */}
                    <Link className="sidebar-brand d-flex align-items-center justify-content-center" to="/home">
                        <div className="sidebar-brand-icon rotate-n-15">
                            <DashboardIcon/>
                        </div>
                        <div className="sidebar-brand-text mx-3">{t('Text_Title')}</div>
                    </Link>

                    {/* Divider */}
                    <hr className="sidebar-divider my-0"/>

                    {/* Nav Item - Dashboard */}
                    <li className="nav-item active">
                        <div className="nav-link">
                            <i className="fas fa-fw fa-tachometer-alt"></i>
                            <span>{t('Menu_Main')}</span></div>
                    </li>

                    {/* Divider */}
                    <hr className="sidebar-divider"/>

                    {/* Sidebar - INFORMATION FILTROS APLICADOS */}
                    <li className="nav-item active">
                        <Link className="nav-link" to="/incidentemail">
                            <FeedIcon/>
                            <span> {t('Text_Information')}</span>
                        </Link>
                    </li> 
                    <div className={filtersSentIncidentsDetails.store_IdToFrom===''?"sidebar-heading":"sidebar-heading text-white"}>   
                        {t('Text_Filter_Email_From')}
                    </div>
                    <li className={filtersSentIncidentsDetails.store_IdToFrom===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                        { filtersSentIncidentsDetails.store_IdToFrom==='' ? t('Text_Filter_Not_Apply'): filtersSentIncidentsDetails.store_IdToFrom}
                    </li>
                    <div className={filtersSentIncidentsDetails.store_IdToTo===''?"sidebar-heading":"sidebar-heading text-white"}>   
                        {t('Text_Filter_Email_to')}
                    </div>
                    <li className={filtersSentIncidentsDetails.store_IdToTo===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                        { filtersSentIncidentsDetails.store_IdToTo==='' ? t('Text_Filter_Not_Apply'): filtersSentIncidentsDetails.store_IdToTo}
                    </li> 

                      <div className={filtersSentIncidentsDetails.formdiFrom===''?"sidebar-heading":"sidebar-heading text-white"}>   
                        {t('Text_Filter_EMAIL_FormDiFrom')}
                    </div>
                    <li className={filtersSentIncidentsDetails.formdiFrom===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                        { filtersSentIncidentsDetails.formdiFrom==='' ? t('Text_Filter_Not_Apply'): filtersSentIncidentsDetails.formdiFrom}
                    </li>
                    <div className={filtersSentIncidentsDetails.formdiTo===''?"sidebar-heading":"sidebar-heading text-white"}>   
                        {t('Text_Filter_EMAIL_FormDiTo')}
                    </div>
                    <li className={filtersSentIncidentsDetails.formdiTo===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                        { filtersSentIncidentsDetails.formdiTo==='' ? t('Text_Filter_Not_Apply'): filtersSentIncidentsDetails.formdiTo}
                    </li> 
 
                     <div className={filtersSentIncidentsDetails.purchaseFrom===''?"sidebar-heading":"sidebar-heading text-white"}>   
                        {t('Text_Filter_EMAIL_PurchaseFrom')}
                    </div>
                    <li className={filtersSentIncidentsDetails.purchaseFrom===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                        { filtersSentIncidentsDetails.purchaseFrom==='' ? t('Text_Filter_Not_Apply'): filtersSentIncidentsDetails.purchaseFrom}
                    </li>
                    <div className={filtersSentIncidentsDetails.purchaseTo===''?"sidebar-heading":"sidebar-heading text-white"}>   
                        {t('Text_Filter_EMAIL_FormDiTo')}
                    </div>
                    <li className={filtersSentIncidentsDetails.purchaseTo===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                        { filtersSentIncidentsDetails.purchaseTo==='' ? t('Text_Filter_Not_Apply'): filtersSentIncidentsDetails.purchaseTo}
                    </li> 
  
 
                    <div className={filtersSentIncidentsDetails.dateEmailFrom===null || filtersSentIncidentsDetails.dateEmailFrom===''?"sidebar-heading":"sidebar-heading text-white"}>   
                        {t('Text_Filter_SENDINCIDENT_Date_From')}
                    </div>
                    <li className={filtersSentIncidentsDetails.dateEmailFrom===null || filtersSentIncidentsDetails.dateEmailFrom===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                        {filtersSentIncidentsDetails.dateEmailFrom===null || filtersSentIncidentsDetails.dateEmailFrom===''? t('Text_Filter_Not_Apply'): new Date(filtersSentIncidentsDetails.dateEmailFrom).toLocaleDateString(i18n.language==="es"?'es-ES':'en-US')}
                    </li>
                    <div className={filtersSentIncidentsDetails.dateEmailTo===null || filtersSentIncidentsDetails.dateEmailTo===''?"sidebar-heading":"sidebar-heading text-white"}>   
                        {t('Text_Filter_SENDINCIDENT_Date_To')}
                    </div>
                    <li className={filtersSentIncidentsDetails.dateEmailTo===null || filtersSentIncidentsDetails.dateEmailTo===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                        { filtersSentIncidentsDetails.dateEmailTo===null || filtersSentIncidentsDetails.dateEmailTo===''? t('Text_Filter_Not_Apply'):new Date(filtersSentIncidentsDetails.dateEmailTo).toLocaleDateString(i18n.language==="es"?'es-ES':'en-US')}
                    </li> 
                    <div className={(filtersSentIncidentsDetails.incidenttypeFromEN==='' && filtersSentIncidentsDetails.incidenttypeFromES==='')?"sidebar-heading":"sidebar-heading text-white"}>
                        {t('Text_Filter_SENDINCIDENT_INICIDENTTYPES_From')}
                    </div>
                    <li className="sidebar-heading text-warning">
                        { i18n.language==="en"?filtersSentIncidentsDetails.incidenttypeFromEN==='' ? t('Text_Filter_Not_Apply'): filtersSentIncidentsDetails.incidenttypeFromEN:filtersSentIncidentsDetails.incidenttypeFromES==='' ? t('Text_Filter_Not_Apply'): filtersSentIncidentsDetails.incidenttypeFromES}
                    </li>
                    <div className={(filtersSentIncidentsDetails.incidenttypeToEN==='' && filtersSentIncidentsDetails.incidenttypeToES==='')?"sidebar-heading":"sidebar-heading text-white"}>
                        {t('PlaceHolder_Filter_SENDINCIDENT_INICIDENTTYPES_To')}
                    </div>
                    <li className="sidebar-heading text-warning">
                        { i18n.language==="en"?filtersSentIncidentsDetails.incidenttypeToEN==='' ? t('Text_Filter_Not_Apply'): filtersSentIncidentsDetails.incidenttypeToEN:filtersSentIncidentsDetails.incidenttypeToES==='' ? t('Text_Filter_Not_Apply'): filtersSentIncidentsDetails.incidenttypeToES}
                    </li>    

                    <div className={!filtersSentIncidentsDetails.isfinished?"sidebar-heading":"sidebar-heading text-white"}>
                        <i className="fas fa-solid fa-circle" style={{color:(filtersSentIncidentsDetails.isfinished)?"#32CD32":"#FFFFFF"}}></i> {t('Text_Filter_SENDINCIDENT_ENDED')}
                    </div>
                    <div className={!filtersSentIncidentsDetails.notisfinished?"sidebar-heading":"sidebar-heading text-white"}>
                        <i className="fas fa-solid fa-circle" style={{color:(filtersSentIncidentsDetails.notisfinished)?"#32CD32":"#FFFFFF"}}></i> {t('Text_Filter_SENDINCIDENT_NOTENDED')}
                    </div> 
                    
                    <li className="sidebar-heading text-warning">
                    &nbsp;
                    </li>
                    {/* Divider */}
                    <hr className="sidebar-divider"/>

                    {/* Heading */}
                    {/* Nav Item - Admin Collapse Menu */}
                    {roles[0].listmenus.find((key)=>(key.name==="Menu_Settings"))&&
                        <li className="nav-item">
                            <Link className="nav-link collapsed" to="/incidentemail" data-toggle="collapse" data-target="#collapseAdmin"
                                aria-expanded="true" aria-controls="collapseAdmin">
                                <SettingsIcon/>
                                <span>{t('Menu_Settings')}</span>
                            </Link>
                            <div id="collapseAdmin" className="collapse" aria-labelledby="headingAdmin"
                                data-parent="#accordionSidebar">
                                <div className="bg-white py-2 collapse-inner rounded">
                                    <h6 className="collapse-header">{t('Custom_Menu_Settings')}</h6>
                                   <Link className="collapse-item" to="/incidentemail" onClick={changeSelectedLanguage}>{i18n.language==="es"?t('SubMenu_Settings_ChangeToEnglish'):t('SubMenu_Settings_ChangeToSpanish')}</Link>
                                   
                                </div>
                            </div>
                        </li>
                    }
                    {/* Nav Item - Charts */}                  
                    <li className="nav-item">
                        <Link className="nav-link" to="/home" onClick={closeModalSentInicidents} >
                            <LogoutIcon/>
                            <span>{t('Button_Back')}</span>
                        </Link>
                    </li>

                    {/* Divider */}
                    <hr className="sidebar-divider d-none d-md-block"/>

                    {/* Sidebar Toggler (Sidebar) */}
                    <div className="text-center d-none d-md-inline">
                        <button className="rounded-circle border-0" id="sidebarToggle"></button>
                    </div>

          
                </ul>
                {/* End of Sidebar */}

                {/* Content Wrapper */}
                <div id="content-wrapper" className="d-flex flex-column">

                {/* Main Content */}
                <div id="content">

                    {/* Topbar  */}
                    <nav className="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">

                        {/* Sidebar Toggle (Topbar)  */}
                        <button id="sidebarToggleTop" className="btn btn-link d-md-none rounded-circle mr-3">
                            <i className="fa fa-bars"></i>
                        </button>
                        
                        {/* Topbar Navbar */}
                        <ul className="navbar-nav ml-auto">
                             <Person/>
                            <div className="topbar-divider d-none d-sm-block"></div>
                                <div className="driver-name-ok">
                                    <br/>
                                    {t('Text_StoreSelected')}&nbsp;{ defaultStore.tradename===null ? t('Text_StoreEmpty'):defaultStore.tradename }
                                </div>   
                            <div className="topbar-divider d-none d-sm-block"></div>
                            {/* Nav Item - Alerts */}
                            <Alerts/>
                            {/* Nav Item - Messages */}
                            <Messages/>
                            <div className="topbar-divider d-none d-sm-block"></div>
                            {/* Nav Item - User Information */}
                            <li className="nav-item dropdown no-arrow mx-1">
                                <br/>
                                <span className="mr-2 d-none d-lg-inline text-gray-600 small">
                                    <TodayIs/>  
                                </span>
                            </li>
                        </ul>
                    </nav>
                    {/* End of Topbar */}

                {/* Show Modals */}  
                <IncidentList  
                    showModalSentInicidents={showModalSentInicidents}
                    setShowModalSentInicidents={setShowModalSentInicidents}
                />
                </div>
                {/* End of Main Content */}

                {/* Footer */}
                <Footer/>
                {/* End of Footer */}

            </div>
            {/* End of Content Wrapper */}

          </div>
          {/* End of Page Wrapper */}
         
      </div>}
      {/* End of Body */}

    </>
  )
};

export default HomeSentIncident;
